import Immutable from "immutable";

import types from "./types";

import { RESET_VOTING_FORM } from "../types";

export const initialState = Immutable.fromJS({
  currentRoute: "select-parent-campaign",
  routes: ["select-parent-campaign", "donate", "thank-you", "vote", "finish"],
  isModalOpen: false,
});

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case types.NEXT_PAGE:
      let indexOfCurrentRoute = state.get("routes").indexOf(state.get("currentRoute"));

      if (indexOfCurrentRoute > -1 && indexOfCurrentRoute < state.get("routes").count()) {
        let indexOfNewRoute = ++indexOfCurrentRoute;
        let newRoute = state.get("routes").toArray()[indexOfNewRoute];

        return state.set("currentRoute", newRoute);
      }

    case types.SET_CURRENT_PAGE:
      return state.set("currentRoute", action.page);

    case types.TOGGLE_MODAL:
      return state.set("isModalOpen", action.bool);

    case types.PREVIOUS_PAGE:
      let indexCurrent = state.get("routes").indexOf(state.get("currentRoute"));

      if (indexCurrent > 0 && indexCurrent <= state.get("routes").count()) {
        let indexNew = --indexCurrent;
        let newRouteName = state.get("routes").toArray()[indexNew];

        return state.set("currentRoute", newRouteName);
      }

    case RESET_VOTING_FORM: {
      return initialState;
    }

    case types.RESET_MODAL_STATE:
      return initialState;

    default:
      return state;
  }
};
